import Cookies from 'js-cookie'

// const TokenKey = 'Jst-PlatformManager'
// Jst-SellerManager
// const ImgTokenKey = 'qiniu-token'
export function getToken(key) {
    return Cookies.get(key)
}

export function setToken(key,token) {
    return Cookies.set(key, token)
}

export function removeToken(key) {
    return Cookies.remove(key)
}

// export function getImgToken() {
//   return Cookies.get(ImgTokenKey)
// }

// export function setImgToken(token) {
//   return Cookies.set(ImgTokenKey, token)
// }

// export function removeImgToken() {
//   return Cookies.remove(ImgTokenKey)
// }
